<template>
  <ToolBar @search="buscar" :configFilter="configFilter" >
    <!-- <ModalCadastro /> -->
    <ModalCadastroRecorrente />
  </ToolBar>
</template>

<script>
/**
 * MIXIN
 */
import toolbar from '@/views/mixins/toolbar'

export default {
  name: `ToolbarCadastroConcursoRecorrente`,
  mixins: [toolbar],
  components: { 
    // ModalCadastro: () => import('./modalCadastro'),
    ModalCadastroRecorrente: () => import('./modalCadastroConcurso'),
    ToolBar: () => import('@/views/components/toolbar')
  }
}
</script>